// src/utils/avatar.js
// Maxula
// Helpers partagés pour les avatars ronds (topbar + sidebar, admin + marchand).

import { normalizeImagePath } from './imageUtils';

// Valeurs considérées comme "pas de vraie photo" -> on bascule sur ui-avatars.
const isPlaceholder = (raw) => {
  if (!raw) return true;
  const s = String(raw).trim();
  if (!s) return true;
  return /avatar-default/i.test(s) || s === 'null' || s === 'undefined';
};

// Nom affiché (prénom + nom, sinon name/fullName, sinon email, sinon "Utilisateur").
export const getDisplayName = (user) => {
  const name = `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
  if (name) return name;
  const single = (user?.name || user?.fullName || user?.displayName || '').trim();
  if (single) return single;
  return user?.email || 'Utilisateur';
};

// Initiales (2 lettres max) pour le fallback texte.
export const getInitials = (user) => {
  const f = String(user?.firstName || '').trim();
  const l = String(user?.lastName || '').trim();
  const init = `${f[0] || ''}${l[0] || ''}`.toUpperCase();
  if (init) return init;
  const email = String(user?.email || '').trim();
  return (email[0] || 'U').toUpperCase();
};

// URL d'avatar rond : vraie photo si dispo, sinon ui-avatars aux couleurs Maxula.
export const getAvatarUrl = (user, { size = 128 } = {}) => {
  const raw = user?.avatar;
  if (!isPlaceholder(raw)) {
    if (/^https?:\/\//i.test(String(raw))) return raw; // URL absolue (ex: Google)
    const norm = normalizeImagePath(raw); // chemin upload -> URL backend
    if (norm) return norm;
  }
  const name = encodeURIComponent(getDisplayName(user));
  return `https://ui-avatars.com/api/?name=${name}&background=E11D79&color=ffffff&bold=true&size=${size}`;
};

// Fallback onError partagé (évite l'icône "image cassée").
export const avatarOnError = (user) => (e) => {
  const el = e.currentTarget;
  el.onerror = null;
  const name = encodeURIComponent(getDisplayName(user));
  el.src = `https://ui-avatars.com/api/?name=${name}&background=E11D79&color=ffffff&bold=true&size=128`;
};
